import React, { Component } from 'react';
import './Home.css';
import Config from '../../config/config';
import NewsGrid from '../NewsGrid';
import HomeProduct from '../../components/HomeProduct';
import ScrollToTopOnMount from '../../components/ScrollToTopOnMount';

class Home extends Component {
  constructor() {
    super();
    this.state = {
      homeProductData: [],
    };
  }

  componentDidMount() {
    fetch(`${Config.apiUrl}/homeproducts`)
      .then(results => results.json())
      .then((data) => {
        this.setState({ homeProductData: data });
      });
  }

  render() {
    return (
      <div className="home ">
        <ScrollToTopOnMount />
        <div className="home-products">
          <div className="container">
            <div className="inner-container">
              <div className="product-title stihl-title">產品情報</div>
              {this.state.homeProductData.length > 0 && (
                <HomeProduct homeProductData={this.state.homeProductData} />
              )}
              {this.state.homeProductData.length === 0 && <div className="product-placeholder" />}
            </div>
          </div>
        </div>

        <div className="home-news container">
          <div className="inner-container">
            <div className="news-title stihl-title">最新消息</div>
            <NewsGrid isShortNews enablePagination={false} />
          </div>
        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/containers/page/Home.js